module.exports = __webpack_public_path__ + "img/bridgerPay.1d7242e6.svg";